// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notifications__scroller {\n  overflow-y: auto;\n  pointer-events: all;\n}", ""]);
// Exports
module.exports = exports;
